// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScrollToBottomButton__button-df9642 {
  position: absolute;
  inset-inline-end: 24px;
  bottom: 24px;
  transition: bottom 0.2s;
  z-index: 1;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/ScrollToBottomButton/ScrollToBottomButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;AACF","sourcesContent":[".button {\n  position: absolute;\n  inset-inline-end: 24px;\n  bottom: 24px;\n  transition: bottom 0.2s;\n  z-index: 1;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `ScrollToBottomButton__button-df9642`
};
module.exports = ___CSS_LOADER_EXPORT___;
